import { composeIO } from 'react-compose-io'
import { modalApiGenerationIO } from './ApiGenerationModal.IO'
import ModalApiGenerationView from './ApiGenerationModal.View'

export const ApiGenerationModal = composeIO(ModalApiGenerationView, modalApiGenerationIO)
